import { Annotation, Inject, Magnification, Navigation, PdfViewerComponent, Toolbar } from '@syncfusion/ej2-react-pdfviewer';

interface EqxPdfViewerProps {
  content: string;
}

const EqxPdfViewer = ({ content }: EqxPdfViewerProps) => {
  const dataUrl = "data:application/pdf;base64," + content.split(",")[1];

  return (
    <div style={{ height: '500px', zIndex: 1, position: 'relative' }}>
      <PdfViewerComponent
        id="pdfViewer"
        documentPath={dataUrl}
        resourceUrl={window.location.origin + "/ej2-pdfviewer-lib"}
      >
        <Inject services={[Toolbar, Magnification, Navigation, Annotation]} />
      </PdfViewerComponent>
    </div>
  );
};

export default EqxPdfViewer; 